import React, { useEffect, useState } from 'react'
import Control from 'components/Control/Control'
import Uploadloader from 'components/Uploader/Uploader'
import FileReaderVisible from 'components/Uploader/FileReaderVisible'
import {
  FormItem,

} from 'modules/Resume/DrawerComponents/EducationDetailStyle'
const UploadForm = ({
    form,
    formName
    
    

}) =>{
    const [file, setFile] = useState(
        form.getFieldValue([[formName], 'doc'])
      )

      useEffect(() => {
        form.setFieldsValue({ [formName]: { doc: file } })
      }, [file])

      return(
        
            <Control flexStart column top="20px">
               <FormItem name={[[formName], 'studentId']}/>
              <FormItem name={[[formName], 'docId']}/>
              <FormItem name={[[formName], 'doc']}
              rules={[
                {
                  required: form.getFieldValue([[formName], 'mandatory']),
                  message: 'Please upload the document!',
                },
              ]}
              >
             

                {file && Object.keys(file)?.length > 0 ? (
                  <Control column top="10px" center>
                    <FileReaderVisible file={file} setFile={setFile} />
                  </Control>
                ) : (
                  <Control column top="10px" center>
                    <Uploadloader
                      setFile={setFile}
                      isDefault={true}
                      fileName={
                        form.getFieldValue([[formName], 'docName'])
                      }
                    />
                  </Control>
                )}
              </FormItem>
            </Control>
        
      )
}

export default UploadForm